import React from "react";
import { Star } from "lucide-react";
import { NETCC_BADGE_SM, NETCC_URL, GOOGLE_REVIEWS, GOOGLE_G_LOGO } from "../../lib/content";
import { useGoogleReviews } from "../../lib/googleReviews";

/**
 * Phase 24 polish — the NETCC + Google-rating pill pair that used to be
 * hand-rolled (with drifting markup) in Home, ThankYou, EnergySwitch and
 * LocationPage. One component, one look.
 *
 * `size="sm"` gives the compact h-8 variant used under dense heroes.
 */
export const TrustStrip = ({ size = "md", className = "", testId = "trust-strip" }) => {
  const h = size === "sm" ? "h-8 text-[12.5px]" : "h-9 text-[13px]";
  const badge = size === "sm" ? "h-5" : "h-6";
  const logo = size === "sm" ? "h-4 w-4" : "h-[16px] w-[16px]";
  const reviews = useGoogleReviews();
  return (
    <ul className={`flex flex-wrap gap-2 ${className}`} data-testid={testId}>
      <li>
        <a
          href={NETCC_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="NETCC approved retailer"
          className={`qv-pill pl-1.5 pr-3.5 ${h}`}
          data-testid="trust-pill-netcc"
        >
          <img
            src={NETCC_BADGE_SM}
            alt=""
            aria-hidden="true"
            width={220}
            height={144}
            className={`${badge} w-auto block`}
            data-testid="trust-pill-netcc-badge"
          />
          NETCC approved
        </a>
      </li>
      <li>
        <a
          href={reviews.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`QVolt Solar, ${reviews.rating} stars from ${reviews.count} Google reviews`}
          className={`qv-pill px-3.5 ${h}`}
          data-testid="trust-pill-google"
        >
          <img src={GOOGLE_G_LOGO} alt="" aria-hidden="true" width={24} height={24} className={`${logo} block`} />
          <span className="font-semibold">{reviews.rating}</span>
          <Star
            className="h-3.5 w-3.5"
            strokeWidth={0}
            style={{ fill: GOOGLE_REVIEWS.star_color, color: GOOGLE_REVIEWS.star_color }}
          />
          <span className="text-subtle">({reviews.count})</span>
        </a>
      </li>
    </ul>
  );
};

export default TrustStrip;
